// src/config/queryClient.js
import { QueryClient } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QUERY_CLIENT_CONFIG, CACHE_TIMES } from './constants';
import { config } from './env';
import packageJson from '../../package.json';

export const queryClient = new QueryClient(QUERY_CLIENT_CONFIG);

export const PERSIST_CACHE_KEY = `REACT_QUERY_OFFLINE_CACHE_${config.companyName}`;

export const localStoragePersister =
  typeof window !== 'undefined'
    ? createSyncStoragePersister({
        storage: window.localStorage,
        key: PERSIST_CACHE_KEY,
      })
    : null;

export const persistOptions = {
  persister: localStoragePersister,
  maxAge: CACHE_TIMES.ONE_DAY,
  buster: `${config.companyName}_${packageJson.version}`,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => query.state.status === 'success',
  },
};